import { UserRoles } from '../api/tenant/models/UserDto'

interface UserRolePillProps {
    value: UserRoles
}

function UserRolePill({ value }: UserRolePillProps): React.JSX.Element {
    // Map values to display text and custom styles
    const displayMap: Record<
        UserRoles,
        { text: string; style: React.CSSProperties }
    > = {
        [UserRoles.HM]: {
            text: 'Hiring Manager',
            style: {
                backgroundColor: '#2ECC71', // Soft green background
                color: 'white',
                padding: '3px 8px',
                borderRadius: '15px', // Rounded pill shape
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'inline-block',
                fontSize: '12px',
            },
        },
        [UserRoles.ADMIN]: {
            text: 'Admin',
            style: {
                backgroundColor: '#E74C3C', // Soft red background
                color: 'white',
                padding: '3px 8px',
                borderRadius: '15px', // Rounded pill shape
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'inline-block',
                fontSize: '12px',
                width: '60px',
            },
        },
        [UserRoles.TA]: {
            text: 'Talent Acquisition',
            style: {
                backgroundColor: '#002d72', // Neutral gray-blue background
                color: 'white',
                padding: '3px 8px',
                borderRadius: '15px', // Rounded pill shape
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'inline-block',
                fontSize: '12px',
            },
        },
    }

    // Use 'undefined' as the default key when value is undefined
    const { text, style } = displayMap[value]

    return <div style={style}>{text}</div>
}

export default UserRolePill
